import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { focusOutlineColors, getHexToRgb } from "../core";
import { css } from 'styled-components';
export var inputStateOutlineStyles = {
  "default": css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: 1px solid rgba(", ", 0.5);\n    border-radius: ", ";\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.color.additional.light.value;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return getHexToRgb(theme.color.additional.dark.value);
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.size.borderRadius.large.value;
  }),
  error: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-color: ", ";\n    box-shadow: 0 0 0 1px ", ";\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return theme.color.system.negative[500].value;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.color.system.negative[500].value;
  }),
  errorAndFocus: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    box-shadow: 0 0 0 1px ", ",\n      0 0 0 5px ", ";\n  "])), function (_ref6) {
    var theme = _ref6.theme;
    return theme.color.system.negative[500].value;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return focusOutlineColors.getSystemNegative(theme);
  }),
  focus: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    border-color: ", ";\n    box-shadow: 0 0 0 1px ", ",\n      0 0 0 5px ", ";\n    caret-color: ", ";\n  "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.color.primary[500].value;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.color.primary[500].value;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return focusOutlineColors.getPrimary(theme);
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.color.primary[500].value;
  }),
  hover: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    box-shadow: 0 0 0 1px rgba(", ", 0.5);\n  "])), function (_ref12) {
    var theme = _ref12.theme;
    return getHexToRgb(theme.color.additional.dark.value);
  })
};